import React from 'react';
import Img from '@Common/components/img';

interface FallbackProps {
  error: Error;
  resetErrorBoundary?: (...args: Array<unknown>) => void;
}

export function ErrorPage({ error }: FallbackProps) {
  const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname.includes('quillbot.dev');

  if (!isDevelopment) {
    error = { name: 'Something went wrong', message: 'Something went wrong' };
  }

  return (
    <div className="container" style={{ textAlign: 'center' }}>
      {isDevelopment && <h3>{error?.name}</h3>}
      <h2>{error?.message}</h2>
      <div style={{ textAlign: 'center' }}>
        <Img alt="ErrorImage" src="/images/500.svg" />
      </div>
    </div>
  );
}
